import Table from '../../components/ui/Table'

const PFAPFCDetailsList = ({ items, header }) => {

  return (
    <div className="!w-full !h-[90vh] py-4 text-left">
      <Table
        data={items}
        header={header}
        fitStrategy="fitGridWidth"
      />
    </div>
  )
}

export default PFAPFCDetailsList;
